import "core-js/modules/es.array.concat.js";
import { request } from '@/api/index';
import { api3 } from "@api/env";
export function getC02Item(confirmId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/".concat(confirmId),
    method: 'get',
    withCredentials: false,
    output: true,
    getHeaders: true
  });
}
export function getHistoryC02Item(confirmId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/".concat(confirmId, "/archived"),
    method: 'get',
    withCredentials: false,
    output: true,
    getHeaders: true
  });
}
export function batchFlow(data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/flow",
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function getC21List(confirmId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/".concat(confirmId, "/confirmData"),
    method: 'get',
    withCredentials: false,
    output: true
  });
}
export function getC21Item(confirmId, confirmDataId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/".concat(confirmId, "/confirmData/").concat(confirmDataId),
    method: 'get',
    withCredentials: false,
    output: true
  });
}